import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.unlockUserInsertUsername.pageTitle',
    defaultMessage: 'Richiesta sblocco utenza',
    description: 'Title of the unlock user insert username page',
  },
  pageSubtitle: {
    id: 'features.unlockUserInsertUsername.pageSubtitle',
    // eslint-disable-next-line quotes
    defaultMessage: "Procedi con lo sblocco dell'utenza",
    description: 'Subtitle of the unlock user insert username page',
  },
  buttonUnlockUserInsertUsername: {
    id: 'features.unlockUserInsertUsername.buttonUnlockUserInsertUsername',
    defaultMessage: 'Invia',
    description: 'Label of the unlock user insert username button',
  },
  backTo: {
    id: 'features.unlockUserInsertUsername.backTo',
    defaultMessage: 'Annulla',
    description: 'Back link',
  },
  labelInsertUsernameUnlockUser: {
    id: 'features.unlockUserInsertUsername.labelInsertUsernameUnlockUser',
    defaultMessage: 'Inserisci username',
    description: 'Label of insert username unlock user input text',
  },
  placeholderInsertUsernameUnlockUser: {
    id: 'features.unlockUserInsertUsername.placeholderInsertUsernameUnlockUser',
    defaultMessage: 'Username da sbloccare',
    description: 'Placeholder of insert username unlock user input text',
  },
  errorTitleInvalidCredentials: {
    id: 'features.unlockUserInsertUsername.errorTitleInvalidCredentials',
    defaultMessage: 'Username non valido',
    description: 'Error message for username not valid',
  },
  successMessageUnlockUser: {
    id: 'features.unlockUserInsertUsername.successMessageUnlockUser',
    defaultMessage:
      'Richiesta sblocco utenza completata. Controlla di aver ricevuto l’email per procedere',
    description: 'Success message unlock user',
  },
  successDialogUnlockUserButtonLabel: {
    id: 'features.unlockUserInsertUsername.successDialogUnlockUserButtonLabel',
    defaultMessage: 'Chiudi',
    description: 'Success dialog unlock user button label',
  },
});
